import { Injectable } from '@angular/core';

// SERVICES
import { Observable } from 'rxjs';

import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getSettingKeyValue(params :{ [key :string] :string }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV1}/settings/keyvalue`, {
      params,
    });
  }
}
